import React, { createContext, useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { useLoad } from "../lib/api";
import { ErrorBox, Loading } from "./kit";

type MeState = { me: any; loading: boolean; error: string | null; reload: () => void };
const MeCtx = createContext<MeState>({ me: null, loading: true, error: null, reload: () => {} });

export function MeProvider({ children }: { children: React.ReactNode }) {
  const { isSignedIn, isLoaded, userId } = useAuth();
  const { data, loading, error, reload } = useLoad(isLoaded && isSignedIn ? `/me?u=${userId}` : null);
  useEffect(() => {
    if (isSignedIn) {
      reload();
    } else if (isLoaded) {
      sessionStorage.removeItem("verge-job-draft");
    }
  }, [isSignedIn, isLoaded, reload]);
  return <MeCtx.Provider value={{ me: isSignedIn ? data : null, loading: !isLoaded || (isSignedIn && loading), error, reload }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);

export function RequireKind({ kind, children }: { kind: string; children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  const { me, loading, error, reload } = useMe();
  if (!isLoaded) return <Loading />;
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  if (error) return <div className="mx-auto max-w-3xl p-6"><ErrorBox message={error} onRetry={reload} /></div>;
  if (loading || !me) return <div className="mx-auto max-w-6xl px-4"><Loading label="Checking access…" /></div>;
  if (me.kind !== kind) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
